import React from "react";
import PrivateRoutes from "./PrivateRoutes";
import Login from "../Auth/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FileStorageComponent from "../components/FileStorageComponent";
import GLIEFComponent from "../components/GLIEFComponent";
import UPIComponent from "../components/UPIComponent";
import UKFirdsComponent from "../components/UKFirdsComponent";
import ClientOrderComponent from "../components/UKCommunicationRecordClientOrderComponent";
import EUFirdsComponent from "../components/EUFirdsComponent";
import UKRecordingKeepingDashboardComponent  from "../components/UKRecordKeepingDashboardComponent";
import RegistrationPage from "../Pages/RegistrationPage";
import ForgotPasswordPage from "../Pages/ForgotPasswordPage";
import SettingsPage from "../Pages/SettingsPage";
import EURecordKeepingDashboardComponent from "../components/EURecordKeepingDashboardComponent";
import EUCommunicationRecordDashboardComponent from "../components/EUCommunicationRecordDashboardComponent";
import UKCommunicationRecordDashboardComponent from "../components/UKCommunicationRecordDashboardComponent";
import ReferenceDataPage from "../Pages/ReferenceDataPage";
const AppRoutes = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route
            exact
            path="/registration-page"
            element={<RegistrationPage />}
          />
          <Route
            exact
            path="/forgot-password"
            element={<ForgotPasswordPage />}
          />
          <Route
            path="/uk-recordkeeping-dashboard"
            element={
              <PrivateRoutes component={UKRecordingKeepingDashboardComponent } />
            }
          />
          <Route
            path="/eu-recordkeeping-dashboard"
            element={
              <PrivateRoutes component={EURecordKeepingDashboardComponent} />
            }
          />
          <Route
            path="/eu-communication-records"
            element={
              <PrivateRoutes
                component={EUCommunicationRecordDashboardComponent}
              />
            }
          />
          <Route
            path="/uk-communication-records"
            element={
              <PrivateRoutes
                component={UKCommunicationRecordDashboardComponent}
              />
            }
          />
          <Route
            path="/regulatory-reference/ukfirds"
            element={<PrivateRoutes component={UKFirdsComponent} />}
          />
          <Route
            path="/regulatory-reference/eufirds"
            element={<PrivateRoutes component={EUFirdsComponent} />}
          />
          <Route
            path="/regulatory-reference/upi"
            element={<PrivateRoutes component={UPIComponent} />}
          />
          <Route
            path="/regulatory-reference/glief"
            element={<PrivateRoutes component={GLIEFComponent} />}
          />
          <Route
            path="/client-order"
            element={<PrivateRoutes component={ClientOrderComponent} />}
          />
          {/* <Route
            path="/communication-record"
            element={<PrivateRoutes component={CommunicationRecordComponent} />}
          /> */}
          {/* <Route
            path="/record-keeping"
            element={<PrivateRoutes component={RecordKeepingComponent} />}
          /> */}

          <Route
            path="/reference-data"
            element={<PrivateRoutes component={ReferenceDataPage} />}
          />
          <Route
            path="/settings"
            element={<PrivateRoutes component={SettingsPage} />}
          />
          <Route
            path="/file-storage"
            element={<PrivateRoutes component={FileStorageComponent} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AppRoutes;
